import isEmpty from 'lodash/isEmpty';
import { fireStore } from '../firebase';

export const getDocs = async ({ filter }) => {
  let docRef = fireStore.collection('campaigns');
  
  if (filter) {
    if (!isEmpty(filter.campaign)) {
      docRef = docRef.where('campaign', '==', filter.campaign);
    }

    if (!isEmpty(filter.industry)) {
      docRef = docRef.where('industry', '==', filter.industry);
    }

    if (!isEmpty(filter.category)) {
      docRef = docRef.where('category', '==', filter.category);
    }
  }
  
  docRef = docRef.orderBy('created_at', 'desc').orderBy('index', 'asc');

  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}

export const addDoc = async ({data}) => {
  return await fireStore.collection('campaigns').add(data);
}

export const updateDoc = async ({data}) => {
  const { id, ...payload } = data;
  return await fireStore.collection('campaigns').doc(id).update(payload);
}

export const deleteDoc = async ({ id }) => {
  return await fireStore.collection('campaigns').doc(id).delete();
}
